<script>
import moment from "moment";
import { mapGetters } from "vuex";

import deleteItemButton from "@/components/lib/delete-item-button";
import editResourceButton from "../edit-resource-button";

import Vuetify from "vuetify/lib";

export default {
  render(h) {
    return h("v-card", { class: "mb-4", scopedSlots: this.$scopedSlots }, [
      this.genToolBar(),
      // this.genProgress(),
      this.genErrors(),
      this.genTable()
    ]);
  },
  name: "RestResourceList",
  data() {
    return {
      allResources: [],
      errors: [],
      loading: false,
      success: false
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup" })
  },
  methods: {
    loadResources() {
      this.loading = true;
      this.success = false;

      this.$http
        .get(`/${this.resourceUrl}/`, {
          params: {
            filter: this.findFilter
          }
        })
        .then(response => {
          this.loading = false;
          this.allResources = [...response.data];
          this.errors = [];
          this.success = true;
        })
        .catch(e => {
          this.loading = false;
          this.handleError(e);
        });
    },
    handleError(e) {
      this.errors.push(e.message);
    },
    genToolBar() {
      let h = this.$createElement;

      return h("v-toolbar", {}, [
        h("v-toolbar-title", {}, this.resourceLabel),
        h("v-spacer"),
        this.genCreateNewButton(),
        h(
          "v-btn",
          { props: { icon: true }, on: { click: this.loadResources } },
          [h("v-icon", {}, "refresh")]
        )
      ]);
    },
    genErrors() {
      let h = this.$createElement;

      var children = [];

      for (let idx of this.errors) {
        children.push(h("li", { key: idx }, idx));
      }

      return h(
        "v-alert",
        { props: { type: "error", value: this.errors.length > 0 } },
        ["Errors were encountered:", h("ul", {}, children)]
      );
    },
    genProgress() {
      if (this.loading == true) {
        return this.$createElement("v-progress-linear", {
          props: { indeterminate: true }
        });
      }
    },
    genTable() {
      // console.log(this.$scopedSlots);
      var h = this.$createElement;

      return h("v-data-table", {
        props: {
          ...this.$props,
          items: this.allResources,
          headers: this.tableHeaders || this.headers,
          itemKey: this.resourceId,
          loading: this.loading,
          "options.sync": this.options
        },
        attrs: this.$attrs,
        scopedSlots: {
          item: this.$scopedSlots.item
            ? this.$scopedSlots.item
            : this.genDefaultItems
        }
      });
    },
    genDefaultItems(props) {
      var item = props.item;
      if (!item) return;

      var children = [];
      for (let header of this.tableHeaders) {
        var value = item[header.value];

        if (typeof header.lookup == "string") {
          let lookup = this.lookup(header.lookup, value);
          value = lookup;
        }

        if (typeof header.customDisplay == "function") {
          value = header.customDisplay(value, item);
        }
        children.push(this.$createElement("td", {}, value));
      }

      // return children;
      return this.$createElement("tr", {}, children);
      // console.log("ScopedSlots: ", this.$scopedSlots);
      // console.log("Slots: ", this.$slots);
      // return this.$slots.items;
    },
    genCreateNewButton() {
      if (this.$scopedSlots.newButton) {
        return this.$scopedSlots.newButton();
      } else if (this.$scopedSlots["new-button"]) {
        return this.$scopedSlots["new-button"]();
      } else {
        return null;
      }

      //  this.$createElement("template", {
      //   props: { ...this.$props },
      //   scopedSlots: { default: this.$scopedSlots.newButton }
      // });
    },
    editLink(resource) {
      return this.$createElement("edit-resource-button", {
        props: { ...this.$props, resource: resource },
        scopedSlots: { default: this.$scopedSlots.form }
      });
    }
  },
  props: {
    resourceName: String,
    resourceUrl: String,
    resourceLabel: String,
    resourceIdField: String,
    resourceId: [String, Array],
    resource: Object,
    findFilter: Object,
    editFilter: Object,
    newResourceTemplate: Object,
    tableHeaders: [Object, Array],
    headers: [Object, Array],
    editForm: [Object, Function, Array]
  },
  filters: {
    currency(amount) {
      return "$" + amount;
    }
  },
  components: {
    "delete-item-button": deleteItemButton,
    editResourceButton,
    ...Vuetify
  },
  created() {
    this.loadResources();
  }
};
</script>
